import { useNavigate, useLocation, Link } from 'react-router-dom';
import styles from './header.module.scss';
import { LogOut, User } from 'lucide-react';
import { logoutUser } from 'store/authSlice';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import React from 'react';
import ThemeToggle from 'components/common/ThemeToggle/themeToggle';

const Header: React.FC = () => {
  const { user } = useAppSelector((state) => state.auth);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useAppDispatch();

  // const getBreadcrumbs = () => {
  //   const paths = location.pathname.split('/').filter(p => p);
  //   if (paths.length === 0) return [{ label: 'Dashboard', path: '/' }];

  //   const breadcrumbs = [];
  //   let currentPath = '';

  //   // Always start with Dashboard if not on root
  //   breadcrumbs.push({ label: 'Dashboard', path: '/' });

  //   paths.forEach((path, index) => {
  //     currentPath += `/${path}`;
  //     let label = path.charAt(0).toUpperCase() + path.slice(1);

  //     if (path === 'sites') label = 'Sites Management';
  //     if (index === 1 && paths[0] === 'sites') label = `Site Details: ${path}`;

  //     breadcrumbs.push({ label, path: currentPath });
  //   });

  //   return breadcrumbs;
  // };

  // const breadcrumbs = getBreadcrumbs();

  const handleLogout = () => {
    dispatch(logoutUser());
    navigate('/login');
  };

  return (
    <header className={styles.header}>
      {/* <div className={styles.breadcrumbContainer}>
        {breadcrumbs.map((crumb, index) => (
          <React.Fragment key={crumb.path}>
            {index > 0 && <span className={styles.separator}>/</span>}
            {index === breadcrumbs.length - 1 ? (
              <span className={styles.currentCrumb}>{crumb.label}</span>
            ) : (
              <Link to={crumb.path} className={styles.breadcrumbLink}>
                {crumb.label}
              </Link>
            )}
          </React.Fragment>
        ))}
      </div> */}
      <div className={styles.spacer}></div>
      <div className={styles.headerActions}>
        <ThemeToggle />
      </div>
      <div className={styles.userMenu}>
        <div className={styles.userInfo}>
          <div className={styles.avatar}>
            <User size={18} />
          </div>
          <span className={styles.username}>{user?.username}</span>
        </div>
        <button
          className={styles.logoutBtn}
          aria-label="Logout"
          title="Logout"
          onClick={handleLogout}
        >
          <LogOut size={18} />
        </button>
      </div>
    </header>
  );
};

export default Header;
